import { Component, Input } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslatePipe } from '@ngx-translate/core';
import { SolEstimatePricingMode } from '../../../models/enum';
import { SolEstimateTableRowBase } from '../../../models/sol-estimate-table/SolEstimateTableRowBase';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NumericMaskDirective } from '../../../shared/numeric/numeric-mask.directive';
import { MatInputModule } from '@angular/material/input';
import { MultilingualCurrencyPipe } from "../../../pipes/multilingual-currency-pipe/multilingual-currency.pipe";
import { DecimalPrecisionPipe } from "../../../pipes/decimal-precision-pipe/decimal-precision.pipe";
import { SolEstimateTableCommonFunctionsService } from '../../../services/sol-estimate-table-common-functions/sol-estimate-table-common-functions.service';

@Component({
  selector: 'app-sol-estimate-table-technology-fee',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    TranslatePipe,
    ReactiveFormsModule,
    CommonModule,
    NumericMaskDirective,
    MultilingualCurrencyPipe,
    DecimalPrecisionPipe
],
  templateUrl: './sol-estimate-table-technology-fee.component.html',
  styleUrl: './sol-estimate-table-technology-fee.component.scss'
})
export class SolEstimateTableTechnologyFeeComponent {

  @Input() isCollaborativeNotEdit: boolean = false;
  @Input() isMarkUpSelected: boolean = false;
  @Input() sellAsPricingMode: SolEstimatePricingMode = SolEstimatePricingMode.Line_Item;
  @Input() technologyFeeFormGroup: FormGroup<SolEstimateTableRowBase>;

  constructor(public readonly solEstimateTableCommonFunctionsService: SolEstimateTableCommonFunctionsService) { }

}
